import { useI18n } from '@ecom/i18n';
import { Skeleton } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

export function TableSkeleton({
  rows = 6,
  columns = 5,
}: {
  rows?: number;
  columns?: number;
}): ReactElement {
  const { t } = useI18n();
  return (
    <div
      className="overflow-hidden rounded-lg border border-line"
      role="status"
      aria-label={t('merchant.common.loadingAria')}
    >
      <div className="flex items-center gap-4 border-b border-line bg-surface2 px-4 py-3">
        {Array.from({ length: columns }, (_, i) => (
          <Skeleton key={i} width="100%" height="0.75rem" />
        ))}
      </div>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div
          key={rowIndex}
          className="flex items-center gap-4 border-b border-lineSoft px-4 py-3.5 last:border-0"
        >
          {Array.from({ length: columns }, (_, colIndex) => (
            <Skeleton key={colIndex} width="100%" height="0.9rem" />
          ))}
        </div>
      ))}
    </div>
  );
}
